<template>
    <!-- Blogs -->
    <section class="py-5">
        <div class="container">
            <h2 class="fw-bold font-serif mb-5">Recent Blogs</h2>
            <div class="row g-4">
                <div class="col-md-4" v-for="blog in blogs" :key="blog.id">
                    <blog-card :blog="blog"></blog-card>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import BlogCard from '../BlogCard.vue';

export default {
    name: "BlogsSection",
    components: {
        BlogCard
    },
    props: {
        blogs: {
            type: Array,
            required: true
        }
    }
}
</script>
